<template>
  <div>
    <Menu/>

    <section id="banner" class="my-5">
      <div class="container">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="banner-section">
              <img v-if="$route.name == 'agents'" src="/images/banner-agents.jpg" class="w-100" />
              <img v-if="$route.name == 'agent'" src="/images/banner-agents-2.jpg" class="w-100" />
              <img v-if="$route.name == 'branches'" src="/images/banner-branches.jpg" class="w-100" />
              <img v-if="$route.name == 'branch'" src="/images/banner-branches-2.jpg" class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-if="loading">
      <center>
        <div class="spinner"></div>
        <p><strong>Loading ...</strong></p>
      </center>
    </div>

    <div v-else>
      <section v-if="$route.name == 'branch'">
        <div class="container">
          <div class="row">
            <template v-for="(branch, index) in branchItems">
              <div
                v-if="branch && branch.id == $route.params.branchId"
                :key="index"
                class="col-md-12"
              >
                <center><h1><strong>{{ branch.branch_name }} Branch</strong></h1></center>
                <center><i class="bi bi-envelope-at-fill"></i> {{ branch.email_address }} &nbsp;&nbsp;&nbsp;&nbsp; <i class="bi bi-telephone-plus-fill"></i> {{ branch.telephone_number }}</center>
                <center><i class="bi bi-geo-alt-fill"></i> {{ branch.postal_address }}</center>
                <center>
                  <iframe
                    width="100%"
                    height="450"
                    frameborder="0"
                    style="border:0"
                    :src="'/map.html?lat=' + branch.map_x_position + '&lng=' + branch.map_y_position + '&zoom=12'"
                    allowfullscreen
                  ></iframe>
                </center>
              </div>
            </template>
          </div>
        </div>

        <center><h1>Branch agents</h1></center>
        <div class="row justify-content-center g-3">
          <div
            v-for="agent in branchAgents"
            :key="agent.id"
            class="col-md-2 px-3 m-3 lifestyle-block switch-bg-lgrey h-100 bord-radius agent-card"
          >
            <a
              v-if="agent.cell_number"
              class="agent-whatsapp-side"
              :href="getWhatsappLink(agent)"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="'WhatsApp ' + agent.first_name + ' ' + agent.last_name"
              title="WhatsApp agent"
            >
              <i class="bi bi-whatsapp"></i>
            </a>
            <div class="container">
              <div class="row pt-2">
                <div class="col-md-12 justify-content-center">
                  <router-link :to="'/agents/' + agent.id" :aria-label="'View profile for '+ agent.first_name + ' ' + agent.last_name">
                    <img :src="agent.agent_photo" class="img img-fluid" style="border-radius: 10px;" loading="lazy" decoding="async" @error="logError" />
                  </router-link>
                </div>
                <div class="col-md-12 text-end mb-2">
                  <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/agents/' + agent.id">
                    <strong>View profile</strong>
                  </router-link>
                  <i class="bi bi-box-arrow-up-right"></i>
                </div>
                <div class="col-md-12">
                  <p class="mt-2">
                    <strong>{{ agent.first_name }} {{ agent.last_name }}</strong><br/>
                    <small style="font-size: 12px;">{{ agent.email_address }}<br/>{{ agent.cell_number }}</small>
                  </p>
                  <div class="pb-3">
                    <span style="font-size: 14px;">{{ agent.branch_name ? agent.branch_name : 'National' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'agent'">
        <div class="container">
          <h1>Agent Profile</h1>
          <div class="row">
            <div v-if="selectedAgent" class="col-md-12 p-3">
              <div class="row pt-2">
                <div class="col-md-3 col-8 p-3">
                  <h2><strong>{{ selectedAgent.first_name }} {{ selectedAgent.last_name }}</strong></h2><br/>
                  <i class="bi bi-envelope-at-fill"></i> {{ selectedAgent.email_address }} <br/>
                  <i class="bi bi-telephone-forward-fill"></i> {{ selectedAgent.cell_number }}
                  <br/>
                  <a
                    v-if="selectedAgent.cell_number"
                    class="agent-profile-whatsapp-link"
                    :href="getWhatsappLink(selectedAgent)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="bi bi-whatsapp"></i> WhatsApp {{ selectedAgent.first_name }}
                  </a>
                  <br/>
                  <h3>
                    {{ selectedAgent.branch_name ? selectedAgent.branch_name : 'National' }}
                    <span v-if="selectedAgent.branch_province">, {{ selectedAgent.branch_province }}</span>
                  </h3>
                </div>
                <div class="col-md-3 col-4 p-3">
                  <center><img :src="selectedAgent.agent_photo" class="img img-fluid" style="border-radius: 10px;" decoding="async" @error="logError" /></center>
                </div>
                <div class="col-md-6 col-12 p-3">
                  <h3>Resumé</h3>
                  <p v-html="decodeResume(selectedAgent.resume)"></p>
                  <div v-if="selectedAgent.id == '881298'">
                    <p>As a seasoned property specialist in the Garden Route, I do more than assist clients in finding a home; I help them embrace a distinctive lifestyle rooted in natural beauty, tranquillity, and luxury.</p>
                    <p>With over 12 years of experience in the real estate industry and a strong focus on the high-end residential market, I provide strategic guidance and in-depth local knowledge to connect discerning buyers and investors with exceptional properties along South Africa’s most iconic coastline. From beachfront villas and eco-estates to hidden lifestyle retreats, I have a deep understanding of the region’s unique offerings and an eye for matching the right property to the right person.</p>
                    <p>My approach is defined by professionalism, integrity, and personalised service. I understand that buying or selling a home is both a financial and emotional investment, which is why I strive to make every interaction meaningful, every detail considered, and every journey seamless from start to finish.</p>
                    <p>Whether you're relocating, expanding your portfolio, or seeking a lifestyle upgrade, I am committed to delivering a real estate experience that is not only successful but also deeply rewarding.</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-md-12 p-3 text-center">
              <p><strong>Agent not found.</strong></p>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'branches'">
        <center><h1>Our branches</h1></center>
        <div class="container">
          <div class="row">
            <div v-for="branch in branchItems" :key="branch.id" class="col-md-4 pb-5">
              <div class="row">
                <div class="col-md-11 bg-light p-3" style="border-radius: 30px; min-height: 250px;">
                  <p><strong>{{ branch.branch_name }} Branch</strong></p>
                  <p><i class="bi bi-geo-alt-fill"></i> {{ branch.province }} - {{ branch.physical_address }}</p>
                  <p><i class="bi bi-telephone-plus-fill"></i> {{ branch.telephone_number }} </p>
                  <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/branches/' + branch.id"><strong>View profile</strong> <i class="bi bi-box-arrow-up-right"></i></router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$route.name == 'agents'">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-7 text-center mb-3">
              <h1 class="mb-3">OUR TEAM</h1>
              <p>Discover an extraordinary assembly of real estate excellence curated by our team of dedicated professionals. We take pride in presenting an unparalleled selection of properties, showcasing the epitome of luxury living in South Africa.</p>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-6 mb-2">
              <center>
                <label for="globalFilter"><strong>Search</strong> by name or surname</label><br/><br/>
                <input type="text" v-model="globalFilter" class="form-control" id="globalFilter">
              </center>
            </div>
          </div>
          <div class="row">
            <div
              v-for="agent in filteredAgents"
              :key="agent.id"
              class="col-6 col-md-2"
              style="border-radius: 30px;"
            >
              <div class="container-fluid m-2 bg-light agent-card">
                <a
                  v-if="agent.cell_number"
                  class="agent-whatsapp-side"
                  :href="getWhatsappLink(agent)"
                  target="_blank"
                  rel="noopener noreferrer"
                  :aria-label="'WhatsApp ' + agent.first_name + ' ' + agent.last_name"
                  title="WhatsApp agent"
                >
                  <i class="bi bi-whatsapp"></i>
                </a>
                <div class="row pt-2" style="min-height: 450px;">
                  <div class="col-md-12">
                    <router-link :to="'/agents/' + agent.id" :aria-label="'View profile for ' + agent.first_name + ' ' + agent.last_name">
                      <img :src="agent.agent_photo" style="border-radius: 10px;" class="img img-fluid" loading="lazy" decoding="async" @error="logError" />
                    </router-link>
                    <router-link style="text-decoration: none; font-weight: bold; font-size: 12px; color: #255699;" :to="'/agents/' + agent.id"><strong>View profile</strong> <i class="bi bi-box-arrow-up-right"></i></router-link><br/><br/>
                    <p>
                      <strong>{{ agent.first_name }} {{ agent.last_name }}</strong><br/>
                      <small style="font-size: 12px;">{{ agent.email_address }}<br/>{{ agent.cell_number }}</small>
                    </p>
                    <div class="pb-3">
                      <i class="bi bi-geo-alt-fill"></i>
                      <span style="font-size: 14px;">{{ agent.branch_name ? agent.branch_name : 'National' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <a
      v-if="$route.name === 'agent' && selectedAgent && selectedAgent.cell_number"
      class="agent-profile-whatsapp-fixed"
      :href="getWhatsappLink(selectedAgent)"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="'WhatsApp ' + selectedAgent.first_name + ' ' + selectedAgent.last_name"
      title="WhatsApp agent"
    >
      <span>{{ selectedAgent.first_name }}</span>
      <i class="bi bi-whatsapp"></i>
    </a>

    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'

const AGENTS_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_agents_localdb.php'
const BRANCHES_API = 'https://luxury-dev.chaseveritt.co.za/api/v3/fetch_branches_localdb.php'

export default {
  components: {
    Menu,
    Footer
  },

  data() {
    return {
      listings: [],
      agents: [],
      branches: [],
      loading: true,
      selectedType: null,
      selectedLocations: [],
      minPrice: 0,
      maxPrice: 100000000,
      priceRange: [0, 100000000],
      originalListings: [],
      currentPage: 1,
      itemsPerPage: 12,
      locationSearch: '',
      navigationArray: [],
      globalFilter: ''
    }
  },

  async mounted() {
    this.loading = true

    const agentsRequest = this.fetchAgents()
    const branchesRequest = this.fetchBranches()

    try {
      if (this.$route.name === 'agents' || this.$route.name === 'agent') {
        // Agent pages must not wait for the separate branches request.
        await agentsRequest
        this.loading = false
        await branchesRequest
      } else if (this.$route.name === 'branches') {
        await branchesRequest
        this.loading = false
        await agentsRequest
      } else {
        // A single branch page needs both the branch and its agents.
        await Promise.all([agentsRequest, branchesRequest])
      }
    } catch (error) {
      console.error('Error loading agents page:', error)
    } finally {
      this.loading = false
    }
  },

  computed: {
    branchItems() {
      return Array.isArray(this.branches) ? this.branches : []
    },

    agentItems() {
      return Array.isArray(this.agents) ? this.agents : []
    },

    filteredAgents() {
      const searchString = (this.globalFilter || '').trim().toLowerCase()

      if (!searchString) {
        return this.agentItems
      }

      return this.agentItems.filter(agent => {
        const firstName = agent.first_name || ''
        const lastName = agent.last_name || ''

        return (
          firstName.toLowerCase().includes(searchString) ||
          lastName.toLowerCase().includes(searchString) ||
          `${firstName} ${lastName}`.toLowerCase().includes(searchString)
        )
      })
    },

    selectedAgent() {
      const agentId = String(this.$route.params.agentId || '')

      return this.agentItems.find(agent => String(agent.id) === agentId) || null
    },

    branchAgents() {
      const branchId = String(this.$route.params.branchId || '')

      return this.agentItems.filter(agent => {
        return this.getAgentBranchIds(agent).includes(branchId)
      })
    }
  },

  methods: {
    getWhatsappLink(agent) {
      if (!agent || !agent.cell_number) {
        return '#'
      }

      let formattedNumber = String(agent.cell_number).replace(/\D/g, '')

      if (formattedNumber.startsWith('00')) {
        formattedNumber = formattedNumber.slice(2)
      }

      if (formattedNumber.startsWith('0')) {
        formattedNumber = `27${formattedNumber.slice(1)}`
      } else if (!formattedNumber.startsWith('27')) {
        formattedNumber = `27${formattedNumber}`
      }

      const firstName = agent.first_name || 'there'
      const profilePath = `/agents/${agent.id}`
      const profileURL = typeof window !== 'undefined'
        ? `${window.location.origin}${profilePath}`
        : `https://luxury-dev.chaseveritt.co.za${profilePath}`
      const message = `Hello ${firstName}, I found your profile on the Chas Everitt Luxury Portfolio website and would like to get in touch: ${profileURL}`

      return `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`
    },

    decodeResume(htmlString) {
      if (typeof htmlString !== 'string') {
        return ''
      }

      const formattedHTML = htmlString.replace(/\n/g, '<br>')

      if (typeof document === 'undefined') {
        return formattedHTML
      }

      const element = document.createElement('div')
      element.innerHTML = formattedHTML

      return element.innerHTML.replace(/â€œ|â€|â€¦|¦|¦/g, '')
    },

    logError(event) {
      event.target.onerror = null
      event.target.src = '/images/generic.jpg'
    },

    normaliseAgents(payload) {
      let rawAgents = []

      if (Array.isArray(payload)) {
        rawAgents = payload
      } else if (payload && Array.isArray(payload.agents)) {
        rawAgents = payload.agents
      }

      return rawAgents
        .map(item => Array.isArray(item) ? item[0] : item)
        .filter(agent => agent && agent.id !== null && typeof agent.id !== 'undefined')
    },

    normaliseBranches(payload) {
      let rawBranches = []

      if (Array.isArray(payload)) {
        rawBranches = payload
      } else if (payload && Array.isArray(payload.branches)) {
        rawBranches = payload.branches
      }

      return rawBranches
        .map(item => Array.isArray(item) ? item[0] : item)
        .filter(branch => branch && branch.id !== null && typeof branch.id !== 'undefined')
    },

    getAgentBranchIds(agent) {
      if (!agent) {
        return []
      }

      const branchIds = []
      const addBranchId = value => {
        if (value === null || typeof value === 'undefined' || value === '') {
          return
        }

        const actualValue = typeof value === 'object' && value.id ? value.id : value

        String(actualValue)
          .split(',')
          .map(id => id.trim())
          .filter(id => id)
          .forEach(id => {
            if (!branchIds.includes(id)) {
              branchIds.push(id)
            }
          })
      }

      const sources = [agent.branch_ids, agent.branches, agent.display_branch]

      sources.forEach(source => {
        if (Array.isArray(source)) {
          source.forEach(addBranchId)
        } else {
          addBranchId(source)
        }
      })

      return branchIds
    },

    updateAgentBranchDetails() {
      if (!this.agentItems.length) {
        return
      }

      const branchLookup = this.branchItems.reduce((lookup, branch) => {
        lookup[String(branch.id)] = branch
        return lookup
      }, {})

      this.agents = this.agentItems.map(agent => {
        const branchIds = this.getAgentBranchIds(agent)
        const matchedBranches = branchIds
          .map(branchId => branchLookup[branchId])
          .filter(branch => branch)

        const branchNames = [...new Set(
          matchedBranches
            .map(branch => branch.branch_name)
            .filter(name => name)
        )]

        const branchProvinces = [...new Set(
          matchedBranches
            .map(branch => branch.province)
            .filter(province => province)
        )]

        return Object.assign({}, agent, {
          branch_ids: branchIds,
          display_branch: agent.display_branch || branchIds[0] || null,
          branch_name: branchNames.length
            ? branchNames.join(', ')
            : (agent.branch_name || ''),
          branch_province: branchProvinces.length
            ? branchProvinces.join(', ')
            : (agent.branch_province || '')
        })
      })
    },

    async fetchBranches() {
      try {
        const response = await axios.get(BRANCHES_API, {
          headers: {
            Accept: 'application/json'
          }
        })

        const branches = this.normaliseBranches(response.data)

        if (branches.length) {
          this.branches = branches
          this.updateAgentBranchDetails()
        }
      } catch (error) {
        console.error('Error fetching branches:', error)
      }
    },

    async fetchAgents() {
      try {
        const response = await axios.get(AGENTS_API, {
          headers: {
            Accept: 'application/json'
          }
        })

        const agents = this.normaliseAgents(response.data)

        if (agents.length) {
          this.agents = agents
          this.updateAgentBranchDetails()
        } else {
          console.warn('The agents endpoint returned no agents:', response.data)
        }
      } catch (error) {
        console.error('Error fetching agents:', error)
      }
    }
  }
}
</script>


<style scoped>
.force-height {
  height: 300px;
  object-fit: cover;
}

.social-links{
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}
/* Scoped keyframes for the spinning animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Spinner class with blue border on top */
.spinner {
  display: inline-block;
  border: 4px solid #f3f3f3; /* Light gray */
  border-top: 4px solid blue; /* Blue top border */
  border-radius: 50%; /* Circular shape */
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* Continuous spinning */
}

.agent-card {
  position: relative;
  overflow: visible;
}

.agent-whatsapp-side {
  position: absolute;
  top: 18px;
  right: -13px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #ffffff;
  color: #0d6efd;
  font-size: 22px;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.agent-whatsapp-side:hover,
.agent-whatsapp-side:focus {
  color: #0d6efd;
  transform: scale(1.08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.24);
}

.agent-profile-whatsapp-link {
  display: inline-block;
  margin-top: 8px;
  color: #0d6efd;
  font-weight: 700;
  text-decoration: none;
}

.agent-profile-whatsapp-link:hover,
.agent-profile-whatsapp-link:focus {
  color: #0d6efd;
  text-decoration: underline;
}

.agent-profile-whatsapp-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  border-top-left-radius: 30px;
  background: #efefef;
  color: #0d6efd;
  font-size: 28px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 -2px 14px rgba(0, 0, 0, 0.12);
}

.agent-profile-whatsapp-fixed span {
  font-size: 11px;
  line-height: 1.1;
}

.agent-profile-whatsapp-fixed:hover,
.agent-profile-whatsapp-fixed:focus {
  color: #0d6efd;
}

@media (max-width: 767px) {
  .agent-whatsapp-side {
    top: 12px;
    right: -8px;
    width: 38px;
    height: 38px;
    font-size: 20px;
  }

  .agent-profile-whatsapp-fixed {
    padding: 11px 14px;
    font-size: 24px;
  }
}
</style>
